module.exports = __webpack_public_path__ + "static/media/emily.c6d965fa.webp";